/*
 * Copyright (c) 2025 Maritime Connectivity Platform Consortium
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * country information collection for the country select menu
 */
export const countryOptions = [
    { code: "AF", code3: "AFG", title: "Afghanistan", value: "Afghanistan" },
    { code: "AL", code3: "ALB", title: "Albania", value: "Albania" },
    { code: "DZ", code3: "DZA", title: "Algeria", value: "Algeria" },
    { code: "AS", code3: "ASM", title: "American Samoa", value: "American Samoa" },
    { code: "AD", code3: "AND", title: "Andorra", value: "Andorra" },
    { code: "AO", code3: "AGO", title: "Angola", value: "Angola" },
    { code: "AI", code3: "AIA", title: "Anguilla", value: "Anguilla" },
    { code: "AQ", code3: "ATA", title: "Antarctica", value: "Antarctica" },
    { code: "AG", code3: "ATG", title: "Antigua and Barbuda", value: "Antigua and Barbuda" },
    { code: "AR", code3: "ARG", title: "Argentina", value: "Argentina" },
    { code: "AM", code3: "ARM", title: "Armenia", value: "Armenia" },
    { code: "AW", code3: "ABW", title: "Aruba", value: "Aruba" },
    { code: "AU", code3: "AUS", title: "Australia", value: "Australia" },
    { code: "AT", code3: "AUT", title: "Austria", value: "Austria" },
    { code: "AZ", code3: "AZE", title: "Azerbaijan", value: "Azerbaijan" },
    { code: "BS", code3: "BHS", title: "Bahamas (the)", value: "Bahamas (the)" },
    { code: "BH", code3: "BHR", title: "Bahrain", value: "Bahrain" },
    { code: "BD", code3: "BGD", title: "Bangladesh", value: "Bangladesh" },
    { code: "BB", code3: "BRB", title: "Barbados", value: "Barbados" },
    { code: "BY", code3: "BLR", title: "Belarus", value: "Belarus" },
    { code: "BE", code3: "BEL", title: "Belgium", value: "Belgium" },
    { code: "BZ", code3: "BLZ", title: "Belize", value: "Belize" },
    { code: "BJ", code3: "BEN", title: "Benin", value: "Benin" },
    { code: "BM", code3: "BMU", title: "Bermuda", value: "Bermuda" },
    { code: "BT", code3: "BTN", title: "Bhutan", value: "Bhutan" },
    { code: "BO", code3: "BOL", title: "Bolivia (Plurinational State of)", value: "Bolivia (Plurinational State of)" },
    { code: "BQ", code3: "BES", title: "Bonaire, Sint Eustatius and Saba", value: "Bonaire, Sint Eustatius and Saba" },
    { code: "BA", code3: "BIH", title: "Bosnia and Herzegovina", value: "Bosnia and Herzegovina" },
    { code: "BW", code3: "BWA", title: "Botswana", value: "Botswana" },
    { code: "BV", code3: "BVT", title: "Bouvet Island", value: "Bouvet Island" },
    { code: "BR", code3: "BRA", title: "Brazil", value: "Brazil" },
    { code: "IO", code3: "IOT", title: "British Indian Ocean Territory (the)", value: "British Indian Ocean Territory (the)" },
    { code: "BN", code3: "BRN", title: "Brunei Darussalam", value: "Brunei Darussalam" },
    { code: "BG", code3: "BGR", title: "Bulgaria", value: "Bulgaria" },
    { code: "BF", code3: "BFA", title: "Burkina Faso", value: "Burkina Faso" },
    { code: "BI", code3: "BDI", title: "Burundi", value: "Burundi" },
    { code: "CV", code3: "CPV", title: "Cabo Verde", value: "Cabo Verde" },
    { code: "KH", code3: "KHM", title: "Cambodia", value: "Cambodia" },
    { code: "CM", code3: "CMR", title: "Cameroon", value: "Cameroon" },
    { code: "CA", code3: "CAN", title: "Canada", value: "Canada" },
    { code: "KY", code3: "CYM", title: "Cayman Islands (the)", value: "Cayman Islands (the)" },
    { code: "CF", code3: "CAF", title: "Central African Republic (the)", value: "Central African Republic (the)" },
    { code: "TD", code3: "TCD", title: "Chad", value: "Chad" },
    { code: "CL", code3: "CHL", title: "Chile", value: "Chile" },
    { code: "CN", code3: "CHN", title: "China", value: "China" },
    { code: "CX", code3: "CXR", title: "Christmas Island", value: "Christmas Island" },
    { code: "CC", code3: "CCK", title: "Cocos (Keeling) Islands (the)", value: "Cocos (Keeling) Islands (the)" },
    { code: "CO", code3: "COL", title: "Colombia", value: "Colombia" },
    { code: "KM", code3: "COM", title: "Comoros (the)", value: "Comoros (the)" },
    { code: "CD", code3: "COD", title: "Congo (the Democratic Republic of the)", value: "Congo (the Democratic Republic of the)" },
    { code: "CG", code3: "COG", title: "Congo (the)", value: "Congo (the)" },
    { code: "CK", code3: "COK", title: "Cook Islands (the)", value: "Cook Islands (the)" },
    { code: "CR", code3: "CRI", title: "Costa Rica", value: "Costa Rica" },
    { code: "HR", code3: "HRV", title: "Croatia", value: "Croatia" },
    { code: "CU", code3: "CUB", title: "Cuba", value: "Cuba" },
    { code: "CW", code3: "CUW", title: "Curaçao", value: "Curaçao" },
    { code: "CY", code3: "CYP", title: "Cyprus", value: "Cyprus" },
    { code: "CZ", code3: "CZE", title: "Czechia", value: "Czechia" },
    { code: "CI", code3: "CIV", title: "Côte d'Ivoire", value: "Côte d'Ivoire" },
    { code: "DK", code3: "DNK", title: "Denmark", value: "Denmark" },
    { code: "DJ", code3: "DJI", title: "Djibouti", value: "Djibouti" },
    { code: "DM", code3: "DMA", title: "Dominica", value: "Dominica" },
    { code: "DO", code3: "DOM", title: "Dominican Republic (the)", value: "Dominican Republic (the)" },
    { code: "EC", code3: "ECU", title: "Ecuador", value: "Ecuador" },
    { code: "EG", code3: "EGY", title: "Egypt", value: "Egypt" },
    { code: "SV", code3: "SLV", title: "El Salvador", value: "El Salvador" },
    { code: "GQ", code3: "GNQ", title: "Equatorial Guinea", value: "Equatorial Guinea" },
    { code: "ER", code3: "ERI", title: "Eritrea", value: "Eritrea" },
    { code: "EE", code3: "EST", title: "Estonia", value: "Estonia" },
    { code: "SZ", code3: "SWZ", title: "Eswatini", value: "Eswatini" },
    { code: "ET", code3: "ETH", title: "Ethiopia", value: "Ethiopia" },
    { code: "FK", code3: "FLK", title: "Falkland Islands (the) [Malvinas]", value: "Falkland Islands (the) [Malvinas]" },
    { code: "FO", code3: "FRO", title: "Faroe Islands (the)", value: "Faroe Islands (the)" },
    { code: "FJ", code3: "FJI", title: "Fiji", value: "Fiji" },
    { code: "FI", code3: "FIN", title: "Finland", value: "Finland" },
    { code: "FR", code3: "FRA", title: "France", value: "France" },
    { code: "GF", code3: "GUF", title: "French Guiana", value: "French Guiana" },
    { code: "PF", code3: "PYF", title: "French Polynesia", value: "French Polynesia" },
    { code: "TF", code3: "ATF", title: "French Southern Territories (the)", value: "French Southern Territories (the)" },
    { code: "GA", code3: "GAB", title: "Gabon", value: "Gabon" },
    { code: "GM", code3: "GMB", title: "Gambia (the)", value: "Gambia (the)" },
    { code: "GE", code3: "GEO", title: "Georgia", value: "Georgia" },
    { code: "DE", code3: "DEU", title: "Germany", value: "Germany" },
    { code: "GH", code3: "GHA", title: "Ghana", value: "Ghana" },
    { code: "GI", code3: "GIB", title: "Gibraltar", value: "Gibraltar" },
    { code: "GR", code3: "GRC", title: "Greece", value: "Greece" },
    { code: "GL", code3: "GRL", title: "Greenland", value: "Greenland" },
    { code: "GD", code3: "GRD", title: "Grenada", value: "Grenada" },
    { code: "GP", code3: "GLP", title: "Guadeloupe", value: "Guadeloupe" },
    { code: "GU", code3: "GUM", title: "Guam", value: "Guam" },
    { code: "GT", code3: "GTM", title: "Guatemala", value: "Guatemala" },
    { code: "GG", code3: "GGY", title: "Guernsey", value: "Guernsey" },
    { code: "GN", code3: "GIN", title: "Guinea", value: "Guinea" },
    { code: "GW", code3: "GNB", title: "Guinea-Bissau", value: "Guinea-Bissau" },
    { code: "GY", code3: "GUY", title: "Guyana", value: "Guyana" },
    { code: "HT", code3: "HTI", title: "Haiti", value: "Haiti" },
    { code: "HM", code3: "HMD", title: "Heard Island and McDonald Islands", value: "Heard Island and McDonald Islands" },
    { code: "VA", code3: "VAT", title: "Holy See (the)", value: "Holy See (the)" },
    { code: "HN", code3: "HND", title: "Honduras", value: "Honduras" },
    { code: "HK", code3: "HKG", title: "Hong Kong", value: "Hong Kong" },
    { code: "HU", code3: "HUN", title: "Hungary", value: "Hungary" },
    { code: "IS", code3: "ISL", title: "Iceland", value: "Iceland" },
    { code: "IN", code3: "IND", title: "India", value: "India" },
    { code: "ID", code3: "IDN", title: "Indonesia", value: "Indonesia" },
    { code: "IR", code3: "IRN", title: "Iran (Islamic Republic of)", value: "Iran (Islamic Republic of)" },
    { code: "IQ", code3: "IRQ", title: "Iraq", value: "Iraq" },
    { code: "IE", code3: "IRL", title: "Ireland", value: "Ireland" },
    { code: "IM", code3: "IMN", title: "Isle of Man", value: "Isle of Man" },
    { code: "IL", code3: "ISR", title: "Israel", value: "Israel" },
    { code: "IT", code3: "ITA", title: "Italy", value: "Italy" },
    { code: "JM", code3: "JAM", title: "Jamaica", value: "Jamaica" },
    { code: "JP", code3: "JPN", title: "Japan", value: "Japan" },
    { code: "JE", code3: "JEY", title: "Jersey", value: "Jersey" },
    { code: "JO", code3: "JOR", title: "Jordan", value: "Jordan" },
    { code: "KZ", code3: "KAZ", title: "Kazakhstan", value: "Kazakhstan" },
    { code: "KE", code3: "KEN", title: "Kenya", value: "Kenya" },
    { code: "KI", code3: "KIR", title: "Kiribati", value: "Kiribati" },
    { code: "KP", code3: "PRK", title: "Korea (the Democratic People's Republic of)", value: "Korea (the Democratic People's Republic of)" },
    { code: "KR", code3: "KOR", title: "Korea (the Republic of)", value: "Korea (the Republic of)" },
    { code: "KW", code3: "KWT", title: "Kuwait", value: "Kuwait" },
    { code: "KG", code3: "KGZ", title: "Kyrgyzstan", value: "Kyrgyzstan" },
    { code: "LA", code3: "LAO", title: "Lao People's Democratic Republic (the)", value: "Lao People's Democratic Republic (the)" },
    { code: "LV", code3: "LVA", title: "Latvia", value: "Latvia" },
    { code: "LB", code3: "LBN", title: "Lebanon", value: "Lebanon" },
    { code: "LS", code3: "LSO", title: "Lesotho", value: "Lesotho" },
    { code: "LR", code3: "LBR", title: "Liberia", value: "Liberia" },
    { code: "LY", code3: "LBY", title: "Libya", value: "Libya" },
    { code: "LI", code3: "LIE", title: "Liechtenstein", value: "Liechtenstein" },
    { code: "LT", code3: "LTU", title: "Lithuania", value: "Lithuania" },
    { code: "LU", code3: "LUX", title: "Luxembourg", value: "Luxembourg" },
    { code: "MO", code3: "MAC", title: "Macao", value: "Macao" },
    { code: "MG", code3: "MDG", title: "Madagascar", value: "Madagascar" },
    { code: "MW", code3: "MWI", title: "Malawi", value: "Malawi" },
    { code: "MY", code3: "MYS", title: "Malaysia", value: "Malaysia" },
    { code: "MV", code3: "MDV", title: "Maldives", value: "Maldives" },
    { code: "ML", code3: "MLI", title: "Mali", value: "Mali" },
    { code: "MT", code3: "MLT", title: "Malta", value: "Malta" },
    { code: "MH", code3: "MHL", title: "Marshall Islands (the)", value: "Marshall Islands (the)" },
    { code: "MQ", code3: "MTQ", title: "Martinique", value: "Martinique" },
    { code: "MR", code3: "MRT", title: "Mauritania", value: "Mauritania" },
    { code: "MU", code3: "MUS", title: "Mauritius", value: "Mauritius" },
    { code: "YT", code3: "MYT", title: "Mayotte", value: "Mayotte" },
    { code: "MX", code3: "MEX", title: "Mexico", value: "Mexico" },
    { code: "FM", code3: "FSM", title: "Micronesia (Federated States of)", value: "Micronesia (Federated States of)" },
    { code: "MD", code3: "MDA", title: "Moldova (the Republic of)", value: "Moldova (the Republic of)" },
    { code: "MC", code3: "MCO", title: "Monaco", value: "Monaco" },
    { code: "MN", code3: "MNG", title: "Mongolia", value: "Mongolia" },
    { code: "ME", code3: "MNE", title: "Montenegro", value: "Montenegro" },
    { code: "MS", code3: "MSR", title: "Montserrat", value: "Montserrat" },
    { code: "MA", code3: "MAR", title: "Morocco", value: "Morocco" },
    { code: "MZ", code3: "MOZ", title: "Mozambique", value: "Mozambique" },
    { code: "MM", code3: "MMR", title: "Myanmar", value: "Myanmar" },
    { code: "NA", code3: "NAM", title: "Namibia", value: "Namibia" },
    { code: "NR", code3: "NRU", title: "Nauru", value: "Nauru" },
    { code: "NP", code3: "NPL", title: "Nepal", value: "Nepal" },
    { code: "NL", code3: "NLD", title: "Netherlands (the)", value: "Netherlands (the)" },
    { code: "NC", code3: "NCL", title: "New Caledonia", value: "New Caledonia" },
    { code: "NZ", code3: "NZL", title: "New Zealand", value: "New Zealand" },
    { code: "NI", code3: "NIC", title: "Nicaragua", value: "Nicaragua" },
    { code: "NE", code3: "NER", title: "Niger (the)", value: "Niger (the)" },
    { code: "NG", code3: "NGA", title: "Nigeria", value: "Nigeria" },
    { code: "NU", code3: "NIU", title: "Niue", value: "Niue" },
    { code: "NF", code3: "NFK", title: "Norfolk Island", value: "Norfolk Island" },
    { code: "MP", code3: "MNP", title: "Northern Mariana Islands (the)", value: "Northern Mariana Islands (the)" },
    { code: "NO", code3: "NOR", title: "Norway", value: "Norway" },
    { code: "OM", code3: "OMN", title: "Oman", value: "Oman" },
    { code: "PK", code3: "PAK", title: "Pakistan", value: "Pakistan" },
    { code: "PW", code3: "PLW", title: "Palau", value: "Palau" },
    { code: "PS", code3: "PSE", title: "Palestine, State of", value: "Palestine, State of" },
    { code: "PA", code3: "PAN", title: "Panama", value: "Panama" },
    { code: "PG", code3: "PNG", title: "Papua New Guinea", value: "Papua New Guinea" },
    { code: "PY", code3: "PRY", title: "Paraguay", value: "Paraguay" },
    { code: "PE", code3: "PER", title: "Peru", value: "Peru" },
    { code: "PH", code3: "PHL", title: "Philippines (the)", value: "Philippines (the)" },
    { code: "PN", code3: "PCN", title: "Pitcairn", value: "Pitcairn" },
    { code: "PL", code3: "POL", title: "Poland", value: "Poland" },
    { code: "PT", code3: "PRT", title: "Portugal", value: "Portugal" },
    { code: "PR", code3: "PRI", title: "Puerto Rico", value: "Puerto Rico" },
    { code: "QA", code3: "QAT", title: "Qatar", value: "Qatar" },
    { code: "MK", code3: "MKD", title: "Republic of North Macedonia", value: "Republic of North Macedonia" },
    { code: "RO", code3: "ROU", title: "Romania", value: "Romania" },
    { code: "RU", code3: "RUS", title: "Russian Federation (the)", value: "Russian Federation (the)" },
    { code: "RW", code3: "RWA", title: "Rwanda", value: "Rwanda" },
    { code: "RE", code3: "REU", title: "Réunion", value: "Réunion" },
    { code: "BL", code3: "BLM", title: "Saint Barthélemy", value: "Saint Barthélemy" },
    { code: "SH", code3: "SHN", title: "Saint Helena, Ascension and Tristan da Cunha", value: "Saint Helena, Ascension and Tristan da Cunha" },
    { code: "KN", code3: "KNA", title: "Saint Kitts and Nevis", value: "Saint Kitts and Nevis" },
    { code: "LC", code3: "LCA", title: "Saint Lucia", value: "Saint Lucia" },
    { code: "MF", code3: "MAF", title: "Saint Martin (French part)", value: "Saint Martin (French part)" },
    { code: "PM", code3: "SPM", title: "Saint Pierre and Miquelon", value: "Saint Pierre and Miquelon" },
    { code: "VC", code3: "VCT", title: "Saint Vincent and the Grenadines", value: "Saint Vincent and the Grenadines" },
    { code: "WS", code3: "WSM", title: "Samoa", value: "Samoa" },
    { code: "SM", code3: "SMR", title: "San Marino", value: "San Marino" },
    { code: "ST", code3: "STP", title: "Sao Tome and Principe", value: "Sao Tome and Principe" },
    { code: "SA", code3: "SAU", title: "Saudi Arabia", value: "Saudi Arabia" },
    { code: "SN", code3: "SEN", title: "Senegal", value: "Senegal" },
    { code: "RS", code3: "SRB", title: "Serbia", value: "Serbia" },
    { code: "SC", code3: "SYC", title: "Seychelles", value: "Seychelles" },
    { code: "SL", code3: "SLE", title: "Sierra Leone", value: "Sierra Leone" },
    { code: "SG", code3: "SGP", title: "Singapore", value: "Singapore" },
    { code: "SX", code3: "SXM", title: "Sint Maarten (Dutch part)", value: "Sint Maarten (Dutch part)" },
    { code: "SK", code3: "SVK", title: "Slovakia", value: "Slovakia" },
    { code: "SI", code3: "SVN", title: "Slovenia", value: "Slovenia" },
    { code: "SB", code3: "SLB", title: "Solomon Islands", value: "Solomon Islands" },
    { code: "SO", code3: "SOM", title: "Somalia", value: "Somalia" },
    { code: "ZA", code3: "ZAF", title: "South Africa", value: "South Africa" },
    { code: "GS", code3: "SGS", title: "South Georgia and the South Sandwich Islands", value: "South Georgia and the South Sandwich Islands" },
    { code: "SS", code3: "SSD", title: "South Sudan", value: "South Sudan" },
    { code: "ES", code3: "ESP", title: "Spain", value: "Spain" },
    { code: "LK", code3: "LKA", title: "Sri Lanka", value: "Sri Lanka" },
    { code: "SD", code3: "SDN", title: "Sudan (the)", value: "Sudan (the)" },
    { code: "SR", code3: "SUR", title: "Surititle", value: "Surititle" },
    { code: "SJ", code3: "SJM", title: "Svalbard and Jan Mayen", value: "Svalbard and Jan Mayen" },
    { code: "SE", code3: "SWE", title: "Sweden", value: "Sweden" },
    { code: "CH", code3: "CHE", title: "Switzerland", value: "Switzerland" },
    { code: "SY", code3: "SYR", title: "Syrian Arab Republic", value: "Syrian Arab Republic" },
    { code: "TW", code3: "TWN", title: "Taiwan", value: "Taiwan" },
    { code: "TJ", code3: "TJK", title: "Tajikistan", value: "Tajikistan" },
    { code: "TZ", code3: "TZA", title: "Tanzania, United Republic of", value: "Tanzania, United Republic of" },
    { code: "TH", code3: "THA", title: "Thailand", value: "Thailand" },
    { code: "TL", code3: "TLS", title: "Timor-Leste", value: "Timor-Leste" },
    { code: "TG", code3: "TGO", title: "Togo", value: "Togo" },
    { code: "TK", code3: "TKL", title: "Tokelau", value: "Tokelau" },
    { code: "TO", code3: "TON", title: "Tonga", value: "Tonga" },
    { code: "TT", code3: "TTO", title: "Trinidad and Tobago", value: "Trinidad and Tobago" },
    { code: "TN", code3: "TUN", title: "Tunisia", value: "Tunisia" },
    { code: "TR", code3: "TUR", title: "Turkey", value: "Turkey" },
    { code: "TM", code3: "TKM", title: "Turkmenistan", value: "Turkmenistan" },
    { code: "TC", code3: "TCA", title: "Turks and Caicos Islands (the)", value: "Turks and Caicos Islands (the)" },
    { code: "TV", code3: "TUV", title: "Tuvalu", value: "Tuvalu" },
    { code: "UG", code3: "UGA", title: "Uganda", value: "Uganda" },
    { code: "UA", code3: "UKR", title: "Ukraine", value: "Ukraine" },
    { code: "AE", code3: "ARE", title: "United Arab Emirates (the)", value: "United Arab Emirates (the)" },
    { code: "GB", code3: "GBR", title: "United Kingdom of Great Britain and Northern Ireland (the)", value: "United Kingdom of Great Britain and Northern Ireland (the)" },
    { code: "UM", code3: "UMI", title: "United States Minor Outlying Islands (the)", value: "United States Minor Outlying Islands (the)" },
    { code: "US", code3: "USA", title: "United States of America (the)", value: "United States of America (the)" },
    { code: "UY", code3: "URY", title: "Uruguay", value: "Uruguay" },
    { code: "UZ", code3: "UZB", title: "Uzbekistan", value: "Uzbekistan" },
    { code: "VU", code3: "VUT", title: "Vanuatu", value: "Vanuatu" },
    { code: "VE", code3: "VEN", title: "Venezuela (Bolivarian Republic of)", value: "Venezuela (Bolivarian Republic of)" },
    { code: "VN", code3: "VNM", title: "Viet Nam", value: "Viet Nam" },
    { code: "VG", code3: "VGB", title: "Virgin Islands (British)", value: "Virgin Islands (British)" },
    { code: "VI", code3: "VIR", title: "Virgin Islands (U.S.)", value: "Virgin Islands (U.S.)" },
    { code: "WF", code3: "WLF", title: "Wallis and Futuna", value: "Wallis and Futuna" },
    { code: "EH", code3: "ESH", title: "Western Sahara", value: "Western Sahara" },
    { code: "YE", code3: "YEM", title: "Yemen", value: "Yemen" },
    { code: "ZM", code3: "ZMB", title: "Zambia", value: "Zambia" },
    { code: "ZW", code3: "ZWE", title: "Zimbabwe", value: "Zimbabwe" },
    { code: "AX", code3: "ALA", title: "Åland Islands", value: "Åland Islands" },
];